import { getCurrentUser } from '@/selectors/user.selectors'
import { useReselector } from '@/utils/sharedHooks'

import { Heading, HeadingVariants, Text } from '@/ui'
import { EnableDialog } from './EnableDialog'
import { DisableDialog } from './DisableDialog'

export const TwoFactorAuthentication = () => {
  const user = useReselector(getCurrentUser)

  return (
    <div className="mb-4 flex flex-col gap-2">
      <Heading variant={HeadingVariants.H2}>Two-factor Authentication</Heading>

      <Text>
        Two-factor authentication (2FA) is an extra layer of security. Once
        enabled, you&#39;ll be required to give two types of identification when
        you log into Heard. We currently support 2FA via SMS only.
      </Text>

      {user?.twoFactorAuthEnabled ? (
        <>
          <Text>
            <i>
              Two-factor authentication is enabled with your phone number ending
              in: {user.phoneNumber?.slice(-4)}
            </i>
          </Text>

          <DisableDialog />
        </>
      ) : (
        <EnableDialog />
      )}
    </div>
  )
}
